import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  Suspense,
} from "react";
import Constants from "../constants/Constants";
import SitesContext from "../context/sites.context";
import Comments from "./Comments";
import PopUp from "./PopUp";
import { IoFlagOutline } from "react-icons/io5";
import AddToLibrary from "./AddToLibrary";
import Loader from "./Loader";
import { navigate } from "@reach/router";
import Tags from "./video/Tags";
const ReportVideo = React.lazy(() => import("./video/Report"));
const Video = ({
  id,
  dispatch,
  biller,
  location,
  favs,
  avatar,
  cacheBust,
  library,
}) => {
  const [info, setInfo] = useState(null);
  const modelsArr = useContext(SitesContext);
  const [playVideo, setPlayVideo] = useState(false);
  const [closeOffer, setCloseOffer] = useState(library.includes(id));
  const [isLibrary, setIsLibrary] = useState(library.includes(id));
  const [isFav, setIsFav] = useState(false);
  const [noAutoPlay, setNoAutoPlay] = useState(false); //PROD FALSE
  const [model, setModel] = useState({});
  const [commentsLoaded, setCommentsLoaded] = useState(false);
  const [showReporting, setShowReporting] = useState(false);
  const [manualPrompt, setManualPrompt] = useState(false);
  const [displayComments, setDisplayComments] = useState([]);
  const videoPlayer = useRef(null);
  const siteInfo = useRef(null);
  const manualPlay = () => {
    videoPlayer.current.play();
    setNoAutoPlay(false);
  };
  const videoPause = () => {
    videoPlayer.current.pause();
  };
  const join = (modelInfo) => {
    setModel(modelInfo);
  };
  const addNewComment = (comment) => {
    setDisplayComments([...displayComments, comment]);
  };
  const showComments = () => {
    if (siteInfo && siteInfo.current && siteInfo.current === "off") {
      setManualPrompt(true);
      return;
    }
    document.body.classList.add(Constants.COMMENT_POP_CLASS);
    if (displayComments.length <= 0) {
      fetch(`${Constants.API}get_video_comments.php?vid=${info.id}`, {
        credentials: "include",
      })
        .then((res) => res.json())
        .then((res) => {
          setDisplayComments(res);
          setCommentsLoaded(true);
        });
    }
  };
  const handlePromptToJoin = () => {
    if (siteInfo && siteInfo.current && siteInfo.current === "off") {
      setManualPrompt(true);
      return;
    } else {
      join(modelsArr[parseInt(info.site_id)]);
    }
  };
  const handleClose = () => {
    if (location.state !== null && "hasBack" in location.state) {
      window.history.back();
    } else {
      navigate(`${Constants.MA}${info.site_url}`);
    }
  };
  const handleFav = () => {
    let formData = new FormData();
    formData.append("fav", !isFav);
    if (!isFav) {
      dispatch({ type: "addFavorite", payload: info.id });
    } else {
      dispatch({ type: "removeFavorite", payload: info.id });
    }

    formData.append("videoid", info.id);
    setIsFav(!isFav);
    fetch(`${Constants.API}fav-video.php`, {
      method: "POST",
      credentials: "include",
      body: formData,
    });
  };
  useEffect(() => {
    const once = {
      once: true,
    };
    const handleEnded = () => {
      if (siteInfo.current === "off") {
        setManualPrompt(true);
        return false;
      }
      setModel(siteInfo.current);
    };
    if (playVideo) {
      if (info !== null && !info.isMember) {
        videoPlayer.current.addEventListener("ended", handleEnded, once);
      }
      const vidPlaya = videoPlayer.current;
      return () => vidPlaya.removeEventListener("ended", handleEnded, once);
    }
  }, [playVideo, videoPlayer, info]);

  useEffect(() => {
    if (playVideo) {
      let promise = videoPlayer.current.play();
      if (promise !== undefined) {
        promise
          .then((_) => {
            setNoAutoPlay(false);
          })
          .catch((error) => {
            setNoAutoPlay(true);
          });
      }
    }
  }, [playVideo]);
  useEffect(() => {
    if (info !== null && favs.includes(info.id)) {
      setIsFav(true);
    }
  }, [favs, info]);

  useEffect(() => {
    fetch(`${Constants.API}getvideo.php?v=${id}&cacheBust=${Date.now()}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (!("error" in res)) {
          setInfo(res);
          if (res.site_id === "0" || res.site_id === 0) {
            siteInfo.current = "off";
          } else if (!res.isMember && res.is_locked === "y") {
            siteInfo.current = "off";
          } else {
            siteInfo.current = modelsArr[parseInt(res.site_id)];
          }

          setPlayVideo(true);
        } else {
          // handle when user is not active for this model
          if ("extra" in res) {
            // display join link and do a shorter video for the upsell.
          }
        }
      });
  }, [id, modelsArr, cacheBust, library]);
  return (
    <div
      className={
        playVideo
          ? info.ratio === "16x9"
            ? "wrapper_video sixteen"
            : "wrapper_video"
          : "active--loading"
      }
    >
      {!playVideo ? (
        <Loader />
      ) : (
        <div className="videoContainer">
          {!closeOffer ? (
            <AddToLibrary
              setCloseOffer={setCloseOffer}
              videoPause={videoPause}
              videoid={id}
              setIsLibrary={setIsLibrary}
              setPlayVideo={setPlayVideo}
              biller={biller}
              dispatch={dispatch}
              manual={manualPrompt}
              price={parseInt(info.price)}
              setModel={setModel}
            />
          ) : null}

          <video
            className="addfriends_video"
            key={`${info.isMember} ${info.id}`}
            controls
            autoPlay
            playsInline
            onContextMenu={(e) => e.preventDefault()}
            ref={videoPlayer}
            preload="metadata"
            poster={`https://static.addfriends.com/vip/posters/${info.file_name.replace(
              ".mp4",
              "-big.jpg"
            )}`}
          >
            <source src={info.cdn} type="video/mp4" />
          </video>
          <div className={closeOffer ? "videoNav" : "videoNav extra"}>
            {isLibrary ? null : (
              <div
                className="videoNavItem"
                onClick={info.isMember ? handleFav : handlePromptToJoin}
              >
                {isFav ? (
                  <i className="icon-heart" />
                ) : (
                  <i className="icon-empty-heart" />
                )}
              </div>
            )}

            {info.site_id !== "0" ? (
              <div className="videoNavItem" onClick={showComments}>
                <i className="icon-message" />
              </div>
            ) : null}

            {isLibrary ? (
              <div className="videoNavItem">
                <a href={`${info.dl}`} rel="noopener noreferrer" download>
                  <i className="icon-download" />
                </a>
              </div>
            ) : null}
            <div
              className="videoNavItem"
              onClick={() => setShowReporting((prev) => !prev)}
            >
              <IoFlagOutline style={{ fontSize: 26, cursor: "pointer" }} />
            </div>
            <div className="videoNavItem" onClick={handleClose}>
              <i className="icon-close" />
            </div>
          </div>
          {noAutoPlay ? (
            <div className="playIcon" onClick={manualPlay}>
              <i className="icon-play" />
            </div>
          ) : null}
        </div>
      )}
      {info && <Tags id={info.id} siteid={info.site_id} />}
      <Comments
        commentsLoaded={commentsLoaded}
        displayComments={displayComments}
        vid={id}
        isMember={info ? info.isMember : false}
        addNewComment={addNewComment}
        avatar={avatar}
        join={join}
        modelInfo={info ? modelsArr[parseInt(info.site_id)] : {}}
      />
      {Object.keys(model).length > 0 ? (
        <PopUp join={join} model={model} dispatch={dispatch} biller={biller} />
      ) : null}

      {showReporting && (
        <Suspense fallback={null}>
          <ReportVideo setShowReporting={setShowReporting} id={id} />
        </Suspense>
      )}
    </div>
  );
};

export default Video;
